<template>
  <b-modal
    id="modal-upload-importacao"
    ref="modalUploadImportacao"
    size="lg"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    modal-class="modal-upload-importacao"
    @hidden="resetarModal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-content">
        <div class="modal-icon">
          <i class="fas fa-cloud-upload-alt"></i>
        </div>

        <div>
          <h5 class="mb-0">
            {{ $t("Importação do CadÚnico") }}
          </h5>
          <small class="text-muted">
            {{ $t("Envie o arquivo e agende o processamento") }}
          </small>
        </div>
      </div>
    </template>

    <div class="upload-modal-body">
      <div class="import-stepper mb-4">
        <div class="steps">
          <div
            v-for="(step, index) in steps"
            :key="step.key"
            class="step"
            :class="{
              active: currentStep === step.key,
              done: doneIndex > index,
            }"
          >
            <div class="circle">
              <i v-if="doneIndex > index" class="fas fa-check"></i>
              <span v-else>{{ index + 1 }}</span>
            </div>

            <div class="label">
              {{ step.label }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="mensagem" class="alert alert-success">
        <i class="fas fa-check-circle mr-1"></i>
        {{ mensagem }}
      </div>

      <div v-if="erro" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle mr-1"></i>
        {{ erro }}
      </div>

      <form v-if="!importacao" @submit.prevent="enviarArquivo">
        <div class="upload-box mb-4" :class="{ 'has-file': arquivo }">
          <input
            id="arquivo-importacao"
            ref="file"
            type="file"
            class="file-input-hidden"
            accept=".txt,.zip"
            :disabled="loading"
            @change="onFileChange"
          />

          <label for="arquivo-importacao" class="upload-box-label">
            <div class="upload-box-content">
              <div class="upload-box-icon">
                <i class="fas fa-file-upload"></i>
              </div>

              <h6 class="mb-1">
                {{
                  arquivo
                    ? arquivo.name
                    : $t("Selecione o arquivo para importação")
                }}
              </h6>

              <p class="text-muted mb-0">
                {{
                  arquivo
                    ? formatarTamanhoArquivo(arquivo.size)
                    : $t("Clique aqui para escolher um arquivo TXT ou ZIP")
                }}
              </p>
            </div>
          </label>
        </div>

        <div class="mb-4">
          <label class="form-label font-weight-bold">
            {{ $t("Entidades para importação") }}
          </label>

          <div class="entidades-grid">
            <label
              v-for="opcao in opcoesEntidades"
              :key="opcao.value"
              class="entidade-option"
              :class="{ selected: entidadesSelecionadas.includes(opcao.value) }"
            >
              <input
                type="checkbox"
                :value="opcao.value"
                v-model="entidadesSelecionadas"
                :disabled="loading"
                @change="onEntidadeChange(opcao.value)"
              />

              <span class="check-icon">
                <i class="fas fa-check"></i>
              </span>

              <span>
                {{ opcao.label }}
              </span>
            </label>
          </div>
        </div>

        <div v-if="loading || uploadProgress > 0" class="mb-4">
          <div class="d-flex justify-content-between mb-1">
            <small class="font-weight-bold">
              {{ progressLabel }}
            </small>
            <small class="font-weight-bold"> {{ uploadProgress }}% </small>
          </div>

          <div class="progress upload-progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="{ width: uploadProgress + '%' }"
              :aria-valuenow="uploadProgress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        <div class="modal-actions">
          <button
            type="button"
            class="btn btn-light"
            :disabled="loading"
            @click="fecharModal"
          >
            {{ $t("Cancelar") }}
          </button>

          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading || !arquivo"
          >
            <span v-if="loading">
              <i class="fas fa-spinner fa-spin mr-1"></i>
              {{ $t("Enviando...") }}
            </span>

            <span v-else>
              <i class="fas fa-cloud-upload-alt mr-1"></i>
              {{ $t("Enviar e agendar") }}
            </span>
          </button>
        </div>
      </form>

      <div v-if="importacao" class="success-content">
        <div class="success-icon">
          <i class="fas fa-check"></i>
        </div>

        <h5 class="mb-2">
          {{ $t("Importação agendada com sucesso") }}
        </h5>

        <p class="text-muted mb-4">
          {{ $t("A importação será processada conforme o agendamento.") }}
        </p>

        <ul class="list-group resumo-list mb-4">
          <li class="list-group-item d-flex justify-content-between">
            <span>{{ $t("ID") }}</span>
            <strong>#{{ importacao.id }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span>{{ $t("Status") }}</span>
            <span class="badge-status badge-status-pendente">
              {{ importacao.status || "pendente" }}
            </span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span>{{ $t("Arquivo") }}</span>
            <strong class="text-right">
              {{ importacao.original_filename || "-" }}
            </strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span>{{ $t("Agendado para") }}</span>
            <strong>{{ formatarData(importacao.scheduled_at) }}</strong>
          </li>
        </ul>

        <div class="modal-actions">
          <button type="button" class="btn btn-light" @click="fecharModal">
            {{ $t("Fechar") }}
          </button>

          <button type="button" class="btn btn-primary" @click="finalizar">
            {{ $t("Ver histórico") }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadImportacaoModal",

  data() {
    return {
      arquivo: null,
      entidadesSelecionadas: ["true"],
      opcoesEntidades: [
        { value: "true", label: "Importar tudo" },
        { value: "localidades", label: "Localidades" },
        { value: "logradouros", label: "Logradouros" },
        { value: "familias", label: "Famílias" },
        { value: "usuarios", label: "Usuários" },
      ],
      loading: false,
      mensagem: "",
      erro: "",
      importacao: null,
      currentStep: "upload",
      uploadProgress: 0,
      progressLabel: "Aguardando envio",
    };
  },

  computed: {
    steps() {
      return [
        { key: "upload", label: this.$t("Upload do arquivo") },
        { key: "schedule", label: this.$t("Agendamento") },
        { key: "done", label: this.$t("Aguardando processamento") },
      ];
    },

    doneIndex() {
      return this.steps.findIndex((step) => step.key === this.currentStep);
    },
  },

  methods: {
    abrirModal() {
      this.$refs.modalUploadImportacao.show();
    },

    fecharModal() {
      if (!this.loading) {
        this.$refs.modalUploadImportacao.hide();
      }
    },

    resetarModal() {
      this.arquivo = null;
      this.entidadesSelecionadas = ["true"];
      this.loading = false;
      this.mensagem = "";
      this.erro = "";
      this.importacao = null;
      this.currentStep = "upload";
      this.uploadProgress = 0;
      this.progressLabel = "Aguardando envio";

      if (this.$refs.file) {
        this.$refs.file.value = "";
      }
    },

    onFileChange(event) {
      this.arquivo = event.target.files[0] || null;
      this.erro = "";
      this.mensagem = "";
      this.uploadProgress = 0;
      this.progressLabel = "Aguardando envio";
    },

    onEntidadeChange(value) {
      if (value === "true" && this.entidadesSelecionadas.includes("true")) {
        this.entidadesSelecionadas = ["true"];
        return;
      }

      if (value !== "true" && this.entidadesSelecionadas.includes(value)) {
        this.entidadesSelecionadas = this.entidadesSelecionadas.filter(
          (item) => item !== "true"
        );
      }

      if (!this.entidadesSelecionadas.length) {
        this.entidadesSelecionadas = ["true"];
      }
    },

    async enviarArquivo() {
      this.loading = true;
      this.erro = "";
      this.mensagem = "";
      this.uploadProgress = 0;
      this.progressLabel = this.$t("Preparando envio");

      try {
        if (!this.arquivo) {
          throw new Error(this.$t("Selecione um arquivo para continuar."));
        }

        const uploadForm = new FormData();
        uploadForm.append("item", this.arquivo);
        uploadForm.append("tipo", "file");
        uploadForm.append("entidades", this.mapearEntidadesParaApi().join(","));

        this.currentStep = "upload";
        this.progressLabel = this.$t("Enviando arquivo");

        const uploadResponse = await axios.post(
          "/api/dashboard/importacao/upload",
          uploadForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (!progressEvent.total) {
                return;
              }

              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          }
        );

        if (!uploadResponse || !uploadResponse.data || !uploadResponse.data.importacao) {
          throw new Error(this.$t("O servidor não confirmou o agendamento. Consulte o histórico antes de enviar novamente."));
        }

        this.currentStep = "schedule";
        this.progressLabel = this.$t("Agendando importação");

        this.importacao = uploadResponse.data.importacao;
        this.mensagem =
          uploadResponse.data.message ||
          this.$t("Importação agendada com sucesso.");

        this.currentStep = "done";
        this.uploadProgress = 100;
        this.progressLabel = this.$t("Concluído");

        this.$emit("uploaded", this.importacao);
      } catch (e) {
        if (e && !e.response && (e.request || e.code === "ECONNABORTED" || e.code === "ETIMEDOUT" || e.code === "ERR_NETWORK")) {
          this.erro = this.$t("Não foi possível confirmar o envio: a conexão foi interrompida ou o servidor demorou para responder. Consulte o histórico de importações antes de enviar novamente, pois o arquivo pode ter sido recebido.");
        } else if (e && e.response && e.response.status === 413) {
          this.erro = this.$t("O arquivo excede o limite de envio do servidor.");
        } else {
          this.erro =
            e?.response?.data?.message ||
            (typeof e === "string" ? e : e?.message) ||
            this.$t("Erro ao enviar arquivo.");
        }

        this.uploadProgress = 0;
        this.progressLabel = this.$t("Falha no envio");
      } finally {
        this.loading = false;
      }
    },

    mapearEntidadesParaApi() {
      const all = this.entidadesSelecionadas.includes("true");

      return [
        all ? "true" : "false",
        all || this.entidadesSelecionadas.includes("localidades")
          ? "true"
          : "false",
        all || this.entidadesSelecionadas.includes("logradouros")
          ? "true"
          : "false",
        all || this.entidadesSelecionadas.includes("familias")
          ? "true"
          : "false",
        all || this.entidadesSelecionadas.includes("usuarios")
          ? "true"
          : "false",
      ];
    },

    formatarData(value) {
      if (!value) {
        return "-";
      }

      return new Date(value).toLocaleString("pt-BR");
    },

    formatarTamanhoArquivo(bytes) {
      if (!bytes) {
        return "-";
      }

      const mb = bytes / 1024 / 1024;

      if (mb >= 1) {
        return `${mb.toFixed(2)} MB`;
      }

      return `${(bytes / 1024).toFixed(2)} KB`;
    },

    finalizar() {
      this.fecharModal();
      // this.$router.push("/dashboard/importacao/");
    },
  },
};
</script>

<style scoped>
.modal-title-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef4ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.upload-modal-body {
  padding: 4px 2px;
}

.import-stepper {
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  padding: 18px;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.step {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  opacity: 0.45;
}

.step:not(:last-child)::after {
  content: "";
  height: 2px;
  background: #dbe4f0;
  flex: 1;
  margin-left: 8px;
}

.step.active,
.step.done {
  opacity: 1;
}

.circle {
  width: 34px;
  min-width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.step.active .circle {
  background: #2563eb;
  color: #fff;
}

.step.done .circle {
  background: #198754;
  color: #fff;
}

.label {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  white-space: nowrap;
}
.file-input-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  z-index: -1;
}

.upload-box {
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  transition: all 0.2s ease;
}

.upload-box:hover,
.upload-box.has-file {
  border-color: #2563eb;
  background: #eef4ff;
}

.upload-box-label {
  display: block;
  width: 100%;
  padding: 28px;
  margin: 0;
  cursor: pointer;
}

.upload-box-content {
  text-align: center;
}

.upload-box-icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: #ffffff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin: 0 auto 14px;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);
}
.entidades-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.entidade-option {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  font-weight: 600;
  color: #334155;
  margin: 0;
  transition: all 0.2s ease;
}

.entidade-option input {
  display: none;
}

.entidade-option:hover {
  border-color: #2563eb;
  background: #f8fafc;
}

.entidade-option.selected {
  border-color: #2563eb;
  background: #eef4ff;
  color: #1d4ed8;
}

.check-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #cbd5e1;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}

.entidade-option.selected .check-icon {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}

.upload-progress {
  height: 10px;
  border-radius: 999px;
  background: #e9ecef;
  overflow: hidden;
}

.upload-progress .progress-bar {
  background: #2563eb;
  transition: width 0.25s ease;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.success-content {
  text-align: center;
}

.success-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #d1e7dd;
  color: #0f5132;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin: 8px auto 18px;
}

.resumo-list {
  text-align: left;
}

.badge-status {
  display: inline-block;
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 0.25rem;
}

.badge-status-pendente {
  color: #856404;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
}

@media (max-width: 768px) {
  .steps {
    flex-direction: column;
    align-items: flex-start;
  }

  .step:not(:last-child)::after {
    display: none;
  }

  .label {
    white-space: normal;
  }

  .entidades-grid {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column-reverse;
  }

  .modal-actions .btn {
    width: 100%;
  }
}
</style>
